import { useIntersectionObserver } from "@react-hookz/web";
import { type FunctionComponent, useEffect, useRef, useState } from "react";

import { DPAScriptId } from "./const";
import { Container } from "./styles";

type Props = {
  path: string;
  src: string;
};

export const MedalWidget: FunctionComponent<Props> = ({ path, src }) => {
  const [isRenderDiv, setIsRenderDiv] = useState(false);

  const element = useRef<HTMLDivElement>(null);
  const observer = useIntersectionObserver(element);

  // Load the DPA script will the widget is in view
  useEffect(() => {
    if (observer?.isIntersecting) {
      setIsRenderDiv(true);
    } else {
      // remove the script when not in view
      const scriptElement = document.querySelector(`#${DPAScriptId}`);
      if (scriptElement) {
        scriptElement.remove();
      }
      setIsRenderDiv(false);
    }
  }, [observer?.isIntersecting]);

  // The DPA script need to be loaded after the DPA div are rendered to make the iframe work, so it need to add in the html level
  useEffect(() => {
    if (!isRenderDiv) return;

    // Check if the script already exists in the document
    if (document.querySelector(`script#${DPAScriptId}`)) return;

    const script = document.createElement("script");
    script.id = "dpa-script";
    script.src = "https://core.dpa-infocom.net/js/dpa.js";
    script.type = "text/javascript";
    script.async = true;
    const head = document.querySelectorAll("head")[0];
    head.append(script);

    return () => {
      if (script) {
        script.remove();
      }
    };
  }, [isRenderDiv]);

  return (
    <Container
      data-app="dpa-sportslive"
      data-competition-id="oly_so"
      data-country="HKG"
      data-custom-font="true"
      data-customer="scmp"
      data-embed-type="iframe-dyn"
      data-language="en"
      data-max-rank="10"
      data-path={path}
      data-path-css="https://assets.i-scmp.com/dpa/medal/2024/"
      data-src={src}
      data-standalone="medalsTable"
      data-timezone="8"
      data-update-time="60"
      ref={element}
    />
  );
};

MedalWidget.displayName = "MedalWidget";
